// Splits a student's exam sheet into pages the size of the board, one shown at a time like the đề.
// Import-free, so node --test can load it.

/** A row's measured top and bottom, in the list's own coordinates. */
export interface RowSpan {
  top: number;
  bottom: number;
}

/** First row of every page: rows fill a page until the next one would spill; a row taller than a page gets its own. */
export function sheetPageStarts(rows: RowSpan[], available: number): number[] {
  if (rows.length === 0 || !(available > 0)) return [0];
  const starts = [0];
  let pageTop = rows[0].top;
  for (let i = 1; i < rows.length; i += 1) {
    if (rows[i].bottom - pageTop > available) {
      starts.push(i);
      pageTop = rows[i].top;
    }
  }
  return starts;
}

/** The page index kept inside [0, count). */
export function clampPage(page: number, count: number): number {
  return Math.max(0, Math.min(page, count - 1));
}

/** Rows [from, to) on `page`. */
export function pageRowRange(starts: number[], rowCount: number, page: number): { from: number; to: number } {
  const at = clampPage(page, starts.length);
  return { from: starts[at], to: at + 1 < starts.length ? starts[at + 1] : rowCount };
}

/** The page holding `row`, so a re-page keeps the question the teacher was on in view. */
export function pageOfRow(starts: number[], row: number): number {
  let page = 0;
  for (let i = 1; i < starts.length; i += 1) {
    if (starts[i] <= row) page = i;
  }
  return page;
}
